export const CHAPS_ADD_MULTIPLE_PAYMENTS = 'CHAPS/ADD_MULTIPLE_PAYMENTS';
export const chapsAddMultiplePayments = (payments) => ({
	type: CHAPS_ADD_MULTIPLE_PAYMENTS,
	payments,
});
